export default "__VITE_ASSET__BXtq3C8$__"